import axios from 'axios'

const url = `${process.env.VUE_APP_API_SERVER}`

class ApiService {
  static sendData(formData) {
    return axios.post(`${url}`, { ...formData },
    {
      headers: {
        'content-type': 'application/json',
      },
    })
  }
}

export default ApiService
